import { createContext } from 'react';
var consentDetailsV2 = {
  consentList: [{
    'blobFileUrl': '',
    'documentName': '',
    'marketplaceName': '',
    'documentTypeId': '',
    'marketplaceAgrmntInfoId': '',
    'version': '',
    'accepted': false,
    'isUserConcentNeeded': true
  }]
};
var defaultState = {
  consentDataV2: consentDetailsV2.consentList,
  setConsentDetailsV2FromInput: function setConsentDetailsV2FromInput(consentData) {
    return consentData;
  }
};
var ConsentDetailsContextV2 = /*#__PURE__*/createContext(defaultState);
export { ConsentDetailsContextV2, consentDetailsV2 };